<template>
	<tr>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					type="text"
					label=""
					placeholder="Enter trandate"
					:dateValue="item.trandate"
					@updateDate="onDate($event, 'trandate')"
					is-date
					is-no-title
					is-required
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select amt"
					type="number"
					:set-input-value="item.amt"
					@updateInput="onInput($event, 'amt')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select card"
					:set-input-value="item.card"
					@updateInput="onInput($event, 'card')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select invoice"
					:set-input-value="item.invoice"
					@updateInput="onInput($event, 'invoice')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select unit"
					:set-input-value="item.unit"
					@updateInput="onInput($event, 'unit')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select drivername"
					:set-input-value="item.drivername"
					@updateInput="onInput($event, 'drivername')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select odometer"
					:set-input-value="item.odometer"
					@updateInput="onInput($event, 'odometer')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select locationname"
					:set-input-value="item.locationname"
					@updateInput="onInput($event, 'locationname')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select city"
					:set-input-value="item.city"
					@updateInput="onInput($event, 'city')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select stateprov"
					:set-input-value="item.stateprov"
					@updateInput="onInput($event, 'stateprov')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select fees"
					:set-input-value="item.fees"
					@updateInput="onInput($event, 'fees')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select item"
					:set-input-value="item.item"
					@updateInput="onInput($event, 'item')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select unitprice"
					:set-input-value="item.unitprice"
					@updateInput="onInput($event, 'unitprice')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select discppu"
					:set-input-value="item.discppu"
					@updateInput="onInput($event, 'discppu')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select disccost"
					:set-input-value="item.disccost"
					@updateInput="onInput($event, 'disccost')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select qty"
					:set-input-value="item.qty"
					@updateInput="onInput($event, 'qty')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					type="number"
					placeholder="Select discamt"
					:set-input-value="item.discamt"
					@updateInput="onInput($event, 'discamt')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select disctype"
					:set-input-value="item.disctype"
					@updateInput="onInput($event, 'disctype')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select db"
					:set-input-value="item.db"
					@updateInput="onInput($event, 'db')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select currency"
					:set-input-value="item.currency"
					@updateInput="onInput($event, 'currency')"
					is-off-style
			></field>
		</td>
	</tr>
</template>

<script>

export default {
	name: "TableFuelTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	methods: {
		onInput({ value }, key) {
			this.$set(this.item, `${ key }`, value);
		},
		onDate(date) {
			this.$set(this.item, 'trandate', date);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "tableTr";
</style>

<style lang="scss">
@import "tableTrGlobal";
</style>
